import React from "react";
import { Route } from "react-router-dom";
import lazyWithRetry from "helpers/lazyWithRetry";

const StatisticsPage = lazyWithRetry(() => import("./StatisticsPage"));
const MapPage = lazyWithRetry(() => import("./MapPage"));

export default [
  <Route
    exact
    path="/statistics"
    key="general-statistics"
    component={StatisticsPage}
  />,
  <Route exact path="/map" key="map" component={MapPage} />,
];
